const utils = require('./utils');
const legacyUrl = require('url');

const modeValues = ['equal', 'subhost', 'regex'];
const modeMatchMethodMap = {
  equal: utils.isDomain,
  regex: utils.isSubDomainRegex,
  subhost: utils.isSubDomain,
};

module.exports = (
  url,
  config = {},
) => {
  try {
    const { schemes, rules, mode } = config;

    let schemeList = ['http', 'https'];
    let ruleList = [];
    let checkMode = 'subhost';

    if (Array.isArray(schemes)) {
      schemeList = [...schemes];
    }
    if (Array.isArray(rules)) {
      ruleList = [...rules];
    }
    if (modeValues.includes(mode)) {
      checkMode = mode;
    }

    if (url.startsWith('/')) {
      // Absolute path returns true
      return true;
    }

    const urlParsed = new URL(url);
    const { hostname } = urlParsed;
    const legacyUrlParsed = legacyUrl.parse(url);

    if (hostname !== legacyUrlParsed.hostname) {
      // Prevent SSRF caused by using legacy API
      return false;
    }

    if (!utils.checkHostname(hostname)) {
      return false;
    }

    // match scheme
    schemeList = schemeList.map(value => `${value}:`);

    if (!schemeList.includes(urlParsed.protocol)) {
      return false;
    }

    const modeMatchMethod = modeMatchMethodMap[checkMode];
    if (modeMatchMethod) {
      return modeMatchMethod(ruleList, hostname);
    }
  } catch (error) {
    console.error('checkUrl catch error', error.toString());
  }
  return false;
};
